export const slug = "audit-log";
export const title = "Audit Log";
export const section = "Administration";
export const content = `
# Audit Log

The Audit Log is an append-only record of every significant action taken in the system.

## What Gets Logged

- Client record created, edited, or deleted
- Household member added or removed
- Visit logged, backfilled, or edited
- Pending approval approved or rejected
- Staff account created, edited, or role changed
- CSV import completed
- Sharing Tree enrollment added or removed
- Duplicate records merged or dismissed
- Settings changed

## How to Read an Entry

Each log entry contains:

- **Timestamp** — exact date and time of the action (UTC).
- **User** — the staff member who performed the action.
- **Action** — a short description (e.g., *Client record updated*).
- **Entity** — the record that was affected (client name, staff email, etc.).
- **Details** — a before/after diff showing exactly what changed.

## Filtering the Log

Use the filter bar to narrow results:

- **By action type** — e.g., show only *Visit logged* entries.
- **By user** — see all actions taken by a specific staff member.
- **By date range** — focus on a specific incident window.
- **By entity** — enter a client name to see all changes to their record.

## Tips

- The audit log is **read-only** — entries cannot be edited or deleted.
- Log entries are retained for 2 years by default.
- If you suspect an unauthorized change, filter by the affected client's name and review the timeline of entries.
`;
